import { faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { IconButton, Tooltip } from "@mui/material";

export const DeleteAction = (props: { onClick: () => void }) => {
    return (
        <Tooltip title={"Delete"}>
            <IconButton onClick={() => props.onClick()}>
                <FontAwesomeIcon icon={faTrash} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );
};
